'use client'

// lib files
import { useHasMounted } from '@/lib/hooks';
import { usePersonalizedResource } from '@/lib/hooks/usePersonalizedResource';
import { myListShows } from '@/lib/resources/my-list-shows';

// types
import type { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

// components
import LinkButton from '@/components/Button/LinkButton';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import MyListShowPosterGrid from '@/components/MyList/MyListShows/MyListShowPosterGrid';
import SignInButton from '@/components/Navigation/SignInButton';

// styles
import styles from './MyListShows.module.scss';

interface MyListShowsProps {
  showBadgeFlags?: ShowBadgeFlags;
}

const MyListShows = ({ showBadgeFlags }: MyListShowsProps) => {
  const shows = usePersonalizedResource(myListShows);
  const hasMounted = useHasMounted();

  if (!hasMounted) return null;

  let content = null;

  switch (shows.status) {
    case 'ready':
      content = <MyListShowPosterGrid shows={shows.items} showBadgeFlags={showBadgeFlags} />;
      break;
    case 'loading':
      content = <LoadingSpinner text="Loading Your List..." />;
      break;
    case 'idle':
    case 'empty':
    case 'error':
      content = (
        <div className={styles.my_list_shows_user_prompt}>
          <h2>Shows you add to My List will appear here.</h2>
          <LinkButton href="/shows/">
            Browse PBS Shows
          </LinkButton>
        </div>
      );
      break;
    case 'needsSignIn':
      content = (
        <div className={styles.my_list_shows_user_prompt}>
          <h2>Sign in to add shows to My List</h2>
          <SignInButton>
            Sign In to Access
          </SignInButton>
        </div>
      );
      break;
  }

  return (
    <div className={styles.my_list_shows}>
     {content}
    </div>
  );
};

export default MyListShows;
